import axios from 'axios';

import { ethers } from "ethers";
import { AssetContractTypeEnum, ContractBase, ListOwnedNFTElement, NetworkEnum, TokenDataBase, TokenDataType } from "./commonInterfacesAndEnums";
import { getNFTsFromMoralis } from './moralisBalance';

export const AlchemySupportedChains = [
  NetworkEnum.mainnet,
  // NetworkEnum.mumbai,
  NetworkEnum.matic,
]

const ipfsGateway = "https://ipfs.io/ipfs/";

// https://dashboard.alchemy.com/
// Use gmail for savvy.shashank@gmail.com

const AlchemyBaseURL = {
  [NetworkEnum.mainnet]: "https://eth-mainnet.alchemyapi.io/nft/v2/zbEVEsP50JjeKSNyEgjrN7cl6FF-88zJ",
  [NetworkEnum.matic]: "https://polygon-mainnet.g.alchemy.com/nft/v2/_tn9X7pFnXwYXYi8Q33gQjRg_B3Dey_4",
  // [NetworkEnum.mumbai]: "https://polygon-mumbai.g.alchemy.com/nft/v2/IcFdYe3mleISObU-2kcTZ0Ljq6rQz_iZ",
  [NetworkEnum.bscMainnet]: "",
  [NetworkEnum.bora]: "",
};




export const AssetContractTypeToTokenDataTypeEnum =
{
  OpenGlipERC1155: "ERC1155",
  GlipLiveERC721: "ERC721",
  GlipPassERC1155: "ERC721",
  ERC20: "ERC20",
  ETH: "ETH",
  NONE: "NONE",
  ERC721: "ERC721",
  ERC1155: "ERC1155",
}



export const getTokensOfAddressFromAlchemy = async (address: string, contracts: ContractBase[] = [], withMetadata: boolean = false, setTokenData: any, _mergeTokensData: any) => {

  let contractsResp: ContractBase[] = [];
  let tokens: ListOwnedNFTElement[] = [];

  if (contracts.length === 0) {
  }

    for (const chain of Object.keys(NetworkEnum)) {
      contracts.map(async (c: any) => {
        if ( !AlchemySupportedChains.includes( chain as NetworkEnum)) {
          const resp = await getNFTsFromMoralis("62fd0e1b5f653536e9c657a8", address, address, [c], [chain as NetworkEnum], true );
          setTokenData(await _mergeTokensData({
            tokens: resp.tokens,
            contracts: resp.contracts,
            currencies: [],
            })
          );          
        } else {
          const {
            contracts: contractArr,
            tokenDatas: tokenDataArr,
            balances } = await getNFTsFromAlchemy(
              address, chain as NetworkEnum, [c.contractAddress], withMetadata);
    
          for (let index = 0; index < tokenDataArr.length; index++) {
            let tokenData = tokenDataArr[index] as TokenDataBase;
            let contract = contractArr[index] as ContractBase;
    
            // Find the matching contract from the contracts array and set assetContractId on tokenData
            // Also set the contract _id and id on contract
            const contractIndex = contracts.findIndex(c => c.contractAddress === contract.contractAddress && c.chain === contract.chain);
            if (contractIndex >= 0) {
              tokenData.assetContractId = contracts[contractIndex].id;
              contract.id = contracts[contractIndex].id;
            }

            setTokenData(await _mergeTokensData({
                tokens: [{
                  token: tokenData,
                  quantity: balances[index].toString(),
                  exchange: []
                }],
                contracts: {[tokenData.id? tokenData.id: 0]: contract},
                currencies: [],
              })
            );
          }
        }
      });        
  }

  return { tokens, contracts: contractsResp };

};

// https://docs.alchemy.com/reference/getnfts
// https://dashboard.alchemy.com/
export const getNFTsFromAlchemy = async (
    address: string, chain: NetworkEnum,
    contracts: string[] = [],
    withMetadata: boolean = false) => {
  // const url = 'https://polygon-mainnet.g.alchemy.com/nft/v2/demo/getNFTs?contractAddresses\\[\\]=0xF553ed185e1A6766a4dF9437cc0F470787c4d3cf&contractAddresses\\[\\]=0xF553ed185e1A6766a4dF9437cc0F470787c4d3cf';
  let url = `${AlchemyBaseURL[chain]}/getNFTs?`;
  let added = false;
  (contracts && contracts.length > 0) && contracts.forEach(contract => {
    (added) && (url += "&");
    url += `contractAddresses\[\]=${contract.toLocaleLowerCase()}`;
    added = true;
  });

  let pageKey;
  let pageSize = 100;
  let totalCount;
  let ownedNfts: any = [];

  try {

    if (!AlchemySupportedChains.includes(chain)) throw new Error("Chain not supported");

    while (true) {
      const params: any = {
        'owner': address,
        'withMetadata': withMetadata,
        'pageSize': pageSize
      };
      if (pageKey) {
        params["pageKey"] = pageKey
      }

      try {

        const response = await axios.get(url, {
          params: params,
          headers: {
            'accept': 'application/json'
          }
        });

        if (response.status === 200) {
          ownedNfts = ownedNfts.concat(response.data.ownedNfts);
          pageKey = response.data.pageKey;
          if (response.data.ownedNfts.length < pageSize) {
            break;
          }
        } else {
          break;
        }
      } catch (error) {
        console.log(error);
        break;
      }
    }

    return parseAlchemyResponse(ownedNfts, chain);

  } catch (error) {
    return parseAlchemyResponse(null, NetworkEnum.mainnet);
  }
}




export const parseAlchemyResponse = (ownedNfts: any, chain: NetworkEnum) => {

  let contracts: ContractBase[] = [];
  const tokenDatas: TokenDataBase[] = [];
  const balances: ethers.BigNumber[] = [];

  (ownedNfts && ownedNfts.length > 0) && ownedNfts.forEach((ownedNft: any) => {

      const contract: ContractBase = {
          chain: chain,
          description: "",
          name: ownedNft.contractMetadata.name,
          symbol: ownedNft.contractMetadata.symbol,
          type: ownedNft.contractMetadata.tokenType,
          confirmed: true,
          contractAddress: ethers.utils.getAddress(ownedNft.contract.address),
          
          isExternal: true,
          isGlobal: false,
      };
      contracts.push(contract);
      
      let imageUri = ownedNft.metadata ?
          ownedNft.metadata.image ?
          ownedNft.metadata.image : ownedNft.metadata.image_url ?
          ownedNft.metadata.image_url : ""
      : "";
      
      imageUri = addIPFSGateway(imageUri);
      let videoUri = ownedNft.metadata ?
          ownedNft.metadata.animation_url ?
          ownedNft.metadata.animation_url : "" : "";
      
      videoUri = addIPFSGateway(videoUri);
      
      const supply = ownedNft.contractMetadata.supply ? ownedNft.contractMetadata.supply : 1;
      
      const attributes = ownedNft.metadata ? ownedNft.metadata.attributes ? ownedNft.metadata.attributes : [] : [];
    let externalMetadataUri = ownedNft.tokenUri.gateway;
      externalMetadataUri = addIPFSGateway(externalMetadataUri);
      
      const tokenId = ownedNft.id.tokenId;
      // convert hex to decimal
      const tokenIdDecimal = ethers.BigNumber.from(tokenId).toString();
      
      const tokenData: TokenDataBase = {
          type: AssetContractTypeToTokenDataTypeEnum[ownedNft.contractMetadata.tokenType as AssetContractTypeEnum] as TokenDataType,
          
          name: ownedNft.title,
          description: ownedNft.description,
          externalUri: ownedNft.metadata.external_url,
          imageUri: imageUri,
          videoUri: videoUri,
          supply: supply,
          decimals: 1,
          attributes: attributes,
          externalMetadataUri: externalMetadataUri,
          tokenId: tokenIdDecimal,
          lazyForm: null,
          encodedFormBytes: null,

      };
      tokenDatas.push(tokenData);
      
      balances.push(ethers.BigNumber.from(ownedNft.balance));
  });
    
    return { contracts, tokenDatas, balances };
    
};

const addIPFSGateway = (uri: string) => {
    if (uri && uri.startsWith("ipfs://")) {
        const parts = uri.substring(7).split("ipfs/");
        return ipfsGateway + parts[parts.length - 1];
    }
  return uri;
};


/**
{
  "ownedNfts": [
    {
      "contract": {
        "address": "0x2953399124f0cbb46d2cbacd8a89cf0599974963"
      },
      "id": {
        "tokenId": "0x43543d7576b0b9c77efe17db8d4ccfd4b419907a000000000000010000002710",
        "tokenMetadata": {
          "tokenType": "ERC1155"
        }
      },
      "balance": "1",
      "title": "Punk Bot 016 (with unlockable content)",
      "description": "Punk Bot 016",
      "tokenUri": {
        "raw": "ipfs://bafkreiak5wvjfdjdhps3myg3cco3atgmwfn4uqfnc5mt5ae5jzl23jjezm",
        "gateway": "https://ipfs.io/ipfs/bafkreiak5wvjfdjdhps3myg3cco3atgmwfn4uqfnc5mt5ae5jzl23jjezm"
      },
      "media": [
        {
          "raw": "",
          "gateway": ""
        }
      ],
      "metadata": {
        "name": "Punk Bot 016 (with unlockable content)",
        "description": "Punk Bot 016",
        "image_url": "ipfs://bafybeidqx6hedgyrdgthnrhdoezy2vfrjqbljo35cbghqoi672okzx5l3e/image"
      },
      "timeLastUpdated": "2022-08-28T20:57:04.223Z",
      "contractMetadata": {
        "name": "OpenSea Collections",
        "symbol": "OPENSTORE",
        "tokenType": "ERC1155"
      }
    },
    {
      "contract": {
        "address": "0xf553ed185e1a6766a4df9437cc0f470787c4d3cf"
      },
      "id": {
        "tokenId": "0x00",
        "tokenMetadata": {
          "tokenType": "ERC1155"
        }
      },
      "balance": "1",
      "title": "FOUNDR DROP",
      "description": "This is the clarion call for awakened Founders (Web3, Web4 & Web5) across the Earth. The on-chain fellowship of awakened Founders has begun, the advent of conscious and mindful foundership. We are extending an awakening invitation to the [Foundr Quest](https://foundr.quest). \n\n*Fellowship access with Alpha Pass (Challenge Edition).\n",
      "tokenUri": {
        "raw": "ipfs://QmYgphz19z96Qcb34jNuvWsxCRtcM4NYAU9ybewzavoEBq/0",
        "gateway": "https://ipfs.io/ipfs/QmYgphz19z96Qcb34jNuvWsxCRtcM4NYAU9ybewzavoEBq/0"
      },
      "media": [
        {
          "raw": "ipfs://QmYXvw2sVfUCQHrBVpfMXdpbSbu5AnpzdPZPzwYo3Ls7Le/0.jpg",
          "gateway": "https://ipfs.io/ipfs/QmYXvw2sVfUCQHrBVpfMXdpbSbu5AnpzdPZPzwYo3Ls7Le/0.jpg"
        }
      ],
      "metadata": {
        "image": "ipfs://QmYXvw2sVfUCQHrBVpfMXdpbSbu5AnpzdPZPzwYo3Ls7Le/0.jpg",
        "external_url": "https://foundr.quest",
        "animation_url": "ipfs://QmYXvw2sVfUCQHrBVpfMXdpbSbu5AnpzdPZPzwYo3Ls7Le/1.mp4",
        "background_color": "",
        "name": "FOUNDR DROP",
        "description": "This is the clarion call for awakened Founders (Web3, Web4 & Web5) across the Earth. The on-chain fellowship of awakened Founders has begun, the advent of conscious and mindful foundership. We are extending an awakening invitation to the [Foundr Quest](https://foundr.quest). \n\n*Fellowship access with Alpha Pass (Challenge Edition).\n",
        "attributes": [
          {
            "value": "1x Access Token",
            "trait_type": "EKOPHILIC-LOBBY"
          },
          {
            "value": "1x Allowlist Spot",
            "trait_type": "ALPHA PASS {CE}"
          }
        ],
        "supply": "126000"
      },
      "timeLastUpdated": "2022-09-11T07:26:59.688Z",
      "contractMetadata": {
        "name": "FOUNDR DROP",
        "symbol": "FOUNDRQUEST",
        "tokenType": "ERC1155"
      }
    }
  ],
  "totalCount": 2,
  "blockHash": "0xbab44fc75807724ea4ea5d5c2769bbb18432740457e11066499e293554190955"
}
 */


